module.exports = __webpack_public_path__ + "media/images/flags/1x1/ton-4242fc757fdad95ef3759022232f7881.svg";